import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import type MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import type FiltersForm from 'modules/core/lib/forms/Filters'

import type Period from 'modules/attendance/store/models/Period'
import type { Status } from 'modules/attendance/store/models/Period'

import type CustomPeriodForm from '../../../Layout/form'
import StateHeader from './../_Header/_State'
import SearchBar from './../_SearchBar'

type SearchBarProps = React.ComponentProps<typeof SearchBar>

interface Props {
  currentTabState: Status
  selected: Period[]
  onDeselectAll: () => void
  payrollCompensation: boolean
  onCompensate: (employeeIds: number[], timestamp: string) => void
  canConfirm: boolean
  search: string
  onSearch: SearchBarProps['onSearch']
  filtersForm: FiltersForm
  customPeriodForm: CustomPeriodForm
  filters: MultiFilterForm[]
  logicOperator: LogicOperatorForm
  onAddFilter: () => void
  onRemoveFilter: (index: number) => void
  onApplyFilters: () => void
  onCancel: () => void
  canSendEmailReminder: boolean
}

const TableOptions = ({
  currentTabState,
  selected,
  onDeselectAll,
  payrollCompensation,
  onCompensate,
  canConfirm,
  search,
  onSearch,
  filtersForm,
  customPeriodForm,
  filters,
  logicOperator,
  onAddFilter,
  onRemoveFilter,
  onApplyFilters,
  onCancel,
  canSendEmailReminder,
}: Props) => {
  return (
    <Box flexDirection="column" flexGrow gap="s16">
      <StateHeader
        currentTabState={currentTabState}
        selected={selected}
        onDeselectAll={onDeselectAll}
        payrollCompensation={payrollCompensation}
        onCompensate={onCompensate}
        canConfirm={canConfirm}
        customPeriodForm={customPeriodForm}
        canSendEmailReminder={canSendEmailReminder}
      />
      <Box flexDirection="row" gap="s8">
        <SearchBar
          search={search}
          onSearch={onSearch}
          filtersForm={filtersForm}
          onAddFilter={onAddFilter}
          onRemoveFilter={onRemoveFilter}
          onApplyFilters={onApplyFilters}
          onCancel={onCancel}
          filters={filters}
          logicOperator={logicOperator}
          canSendEmailReminder={canSendEmailReminder}
        />
      </Box>
    </Box>
  )
}

export default observer(TableOptions)
